export const ACTION_ERROR = 'errors'
export const ACTION_FORM_ERROR = 'formErrors'
export const ACTION_PAYLOAD = 'payload'
export const ACTION_QUERY = 'query'
